<template>
  <div>
    <div class="d-flex">
      <div :class="!switchValue ? 'active_label' : 'non_active_label'" class="label_font">
        {{ label1 }}
      </div>
      <div class="line_box"></div>
      <div :class="switchValue ? 'active_label' : 'non_active_label'" class="label_font">
        {{ label2 }}
      </div>
    </div>
    <div class="d-flex justify-center pt-1">
      <label class="toggle">
        <input
          class="toggle-checkbox"
          type="checkbox"
          v-bind="$attrs"
          v-model="switchValue"
          @change="changeValue"
        />
        <div class="toggle-switch"></div>
      </label>
    </div>
  </div>
</template>
<script>
export default {
  name: "ToggleComponent",
  props: {
    label1: {
      default: "Public",
      type: String,
    },
    label2: {
      default: "All Trades",
      type: String,
    },
    value: {},
  },
  data() {
    return {
      switchValue: false,
    };
  },
  computed: {},
  watch: {},
  methods: {
    changeValue() {
      this.value = this.switchValue;
      //   console.log(this.value, "value");
      this.$emit("input", this.value);
    },
  },
  mounted() {},
};
</script>
<style scoped>
.toggle {
  cursor: pointer;
  display: inline-block;
}

.toggle-switch {
  display: inline-block;
  background: #2d8cff;
  border-radius: 16px;
  width: 55px;
  height: 31px;
  position: relative;
  vertical-align: middle;
  transition: background 0.25s;
}
.toggle-switch:before,
.toggle-switch:after {
  content: "";
}
.toggle-switch:before {
  display: block;
  background: linear-gradient(to bottom, #fff 0%, #eee 100%);
  border-radius: 50%;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.25);
  width: 24px;
  height: 24px;
  position: absolute;
  top: 4px;
  left: 4px;
  transition: left 0.25s;
}
.toggle:hover .toggle-switch:before {
  background: linear-gradient(to bottom, #fff 0%, #fff 100%);
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.5);
}
.toggle-checkbox:checked + .toggle-switch {
  background: #2d8cff;
}
.toggle-checkbox:checked + .toggle-switch:before {
  left: 30px;
}

.toggle-checkbox {
  position: absolute;
  visibility: hidden;
}

.toggle-label {
  margin-left: 5px;
  position: relative;
  top: 2px;
}
.non_active_label {
  display: flex;
  padding: 4px 8px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 4px;
  border: 1px solid #e4e4e4;
  background: #fff;
  color: #656668;
}
.active_label {
  display: flex;
  padding: 4px 8px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 4px;
  border: 1px solid #e4e4e4;
  background: #fff;
  color: #2d8cff;
}
.label_font {
  min-width: 80px;
  font-family: Avenir;
  font-size: 13px;
  font-style: normal;
  font-weight: 800;
  line-height: normal;
}
.line_box {
  width: 1px;
  height: 16px;
  border-radius: 10px;
  background: #a7a7a7;
  margin: 5px;
}
@media all and (max-width: 600px) {
  .label_font {
    min-width: 70px;
    font-family: Avenir;
    font-size: 10px;
    font-style: normal;
    font-weight: 800;
    line-height: normal;
  }
  .toggle-switch {
    display: inline-block;
    background: #2d8cff;
    border-radius: 16px;
    width: 40px;
    height: 24px;
    position: relative;
    vertical-align: middle;
    transition: background 0.25s;
  }
  .toggle-switch:before {
    display: block;
    background: linear-gradient(to bottom, #fff 0%, #eee 100%);
    border-radius: 50%;
    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.25);
    width: 16px;
    height: 16px;
    position: absolute;
    top: 4px;
    left: 4px;
    transition: left 0.25s;
  }
  .toggle-checkbox:checked + .toggle-switch:before {
    left: 20px;
  }
}
</style>
